import {
  IReportYearly,
  IReportWeekly,
  IReportMonthly,
} from '../../models/Reports';

export const FETCH_REPORT_DATA = 'FETCH_REPORT_DATA';
export const FETCH_REPORT_DATA_SUCCESS = 'FETCH_REPORT_DATA_SUCCESS';
export const FETCH_REPORT_DATA_ERROR = 'FETCH_REPORT_DATA_ERROR';

export enum ReportPeriod {
  YEARLY,
  MONTHLY,
  WEEKLY,
}

export interface FetchReportData {
  type: typeof FETCH_REPORT_DATA;
}

export interface FetchReportDataError {
  type: typeof FETCH_REPORT_DATA_ERROR;
}

interface PayloadYearly {
  slug: string;
  period: ReportPeriod.YEARLY;
  data: IReportYearly[];
}
interface PayloadMonthly {
  slug: string;
  period: ReportPeriod.MONTHLY;
  data: IReportMonthly[];
}
interface PayloadWeekly {
  slug: string;
  period: ReportPeriod.WEEKLY;
  data: IReportWeekly[];
}
export interface FetchReportDataSuccess {
  type: typeof FETCH_REPORT_DATA_SUCCESS;
  payload: PayloadYearly | PayloadMonthly | PayloadWeekly;
}

export type ReportsActionTypes =
  | FetchReportData
  | FetchReportDataError
  | FetchReportDataSuccess;
